import { render, staticRenderFns } from "./insurance_card_settings.vue?vue&type=template&id=05ee567c&"
import script from "./insurance_card_settings.vue?vue&type=script&lang=js&"
export * from "./insurance_card_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports